import { defineComponent as _defineComponent } from 'vue'
import ExtensionBar from "#src/components/ExtensionBar.vue";
import Tutorial from "#src/components/Tutorial.vue";

import { loaded } from "#src/store.js";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { ExtensionBar, Tutorial, get loaded() { return loaded } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})